export default __webpack_public_path__ + "new-energyea7929.png";